<nb-card
  [status]="receipt.isCancel ? 'danger' : 'basic'"
  [nbSpinner]="loading"
  nbSpinnerStatus="info"
>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="content">
          <div>
            <nb-icon icon="calendar-outline"></nb-icon>
            <span class="link text-hint">
              {{ receipt.issueDate | date: "dd/MM/yyyy HH:mm" }}</span
            >
          </div>

          <div class="customer-info">
            <h6 class="link text-body">
              {{ receipt.customerName }}
              <span *ngIf="receipt.customerMobile" class="link text-hint">
                - {{ receipt.customerMobile }}
              </span>
            </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <a class="link">
        <h5 class="text-primary">{{ receipt.totalAmount | number }}</h5>
      </a>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="content">
      <div class="receipt-detail table-responsive">
        <table class="receipt-detail table table-striped">
          <thead class="thead-light">
            <tr>
              <th scope="col">#</th>
              <!-- <th *ngIf="receipt.isTrade" scope="col">NCC</th>
              <th *ngIf="receipt.isTrade" scope="col">Tiền mua</th> -->
              <th scope="col">{{ "product.code" | translate }}</th>
              <th scope="col">{{ "product.name" | translate }}</th>
              <th scope="col">{{ "product.unit" | translate }}</th>
              <th scope="col" class="col-number">
                {{ "common.unitPrice" | translate }}
              </th>
              <th scope="col" class="col-number">
                {{ "common.quantityShort" | translate }}
              </th>
              <th scope="col" class="col-number">
                {{ "common.discountAmount" | translate }}
              </th>
              <th scope="col" class="col-number">
                {{ "common.totalAmount" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let item of receipt?.receiptOrderDetails; let i = index"
            >
              <td class="col-no">
                {{ i + 1 }}
              </td>
              <!-- <td *ngIf="receipt.isTrade">
                {{ item.supplierName }}
              </td>
              <td *ngIf="receipt.isTrade" class="col-number">
                {{ item.costAmount | number }}
              </td> -->
              <td>
                {{ item.productCode }}
              </td>
              <td>
                {{ item.productName }}
                <span *ngIf="item.comment">( {{ item.comment }} )</span>
              </td>
              <td>
                {{ item.productUnitName }}
              </td>
              <td class="col-number">
                {{ item.price | number }}
              </td>
              <td class="col-number">
                {{ item.quantity | number }}
              </td>
              <td class="col-number">
                {{ item.discountAmount | number }}
              </td>
              <td class="col-number">
                <strong>{{ item.amount | number }}</strong>
              </td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <!-- <td class="col-label" [colSpan]="receipt.isTrade ? 7 : 5"> -->
              <td class="col-label" colspan="5">
                <strong class="text-hint">TỔNG CỘNG</strong>
              </td>
              <td class="col-number">
                <strong class="text-primary">
                  {{ receipt.totalQuantity | number }}
                </strong>
              </td>
              <td></td>
              <td class="col-number">
                <strong class="text-primary">
                  {{ receipt.detailAmount | number }}
                </strong>
              </td>
            </tr>
            <tr *ngIf="receipt.customerAddress">
              <!-- <td [colSpan]="receipt.isTrade ? 10 : 8"> -->
              <td class="col-label" colspan="8">
                <label class="text-hint"
                  >{{ "common.address" | translate }}:</label
                >
                <span class="description"> {{ receipt.customerAddress }} </span>
              </td>
            </tr>
            <tr *ngIf="receipt.note">
              <!-- <td [colSpan]="receipt.isTrade ? 10 : 8"> -->
              <td class="col-label" colspan="8">
                <label class="text-hint"
                  >{{ "common.note" | translate }}:</label
                >
                <span class="description"> {{ receipt.note }} </span>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>

      <div class="receipt-info">
        <table class="table table-borderless">
          <tr>
            <td class="col-label">
              <label class="label">
                {{ "common.netAmount" | translate }}:</label
              >
            </td>
            <td class="col-number">
              <strong class="text-body">
                {{ receipt.detailNetAmount | number }}
              </strong>
            </td>
          </tr>

          <tr *ngIf="receipt.totalDiscountAmount > 0">
            <td class="col-label">
              <label class="label"
                >{{ "common.totalDiscountAmount" | translate }}:</label
              >
            </td>
            <td class="col-number">
              <span class="text-body">
                {{ receipt.totalDiscountAmount | number }}
              </span>
            </td>
          </tr>
          <tr *ngIf="receipt.vatAmount > 0">
            <td class="col-label">
              <label class="label">VAT:</label>
            </td>
            <td class="col-number">
              <span class="text-body">
                {{ receipt.vatAmount | number }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="col-label">
              <label class="label">
                {{ "common.totalAmount" | translate }}:</label
              >
            </td>
            <td class="col-number">
              <strong class="text-danger">
                {{ receipt.totalAmount | number }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="col-label">
              <label class="label">{{ "common.status" | translate }}:</label>
            </td>
            <td class="col-number">
              <strong
                class="text-success"
                [ngClass]="
                  receipt.isCancel
                    ? 'text-danger'
                    : receipt.isClosed
                      ? 'text-success'
                      : 'text-info'
                "
              >
                {{ receipt.status }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="col-label">
              <label class="label">{{ "common.cashier" | translate }}:</label>
            </td>
            <td class="col-number">
              <span class="text-body description">
                {{ receipt.author?.email }}
              </span>
            </td>
          </tr>
          <tr *ngIf="receipt.employeeCounSellorName">
            <td class="col-label">
              <label class="label">NV Tư vấn:</label>
            </td>
            <td class="col-number">
              <span class="text-body description">
                {{ receipt.employeeCounSellorName }}
              </span>
            </td>
          </tr>
          <tr *ngIf="receipt.employeeSaleName">
            <td class="col-label">
              <label class="label">NV Kinh doanh:</label>
            </td>
            <td class="col-number">
              <span class="text-body description">
                {{ receipt.employeeSaleName }}
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="detail">
      <div class="button-action">
        <button
          *ngIf="user.admin || user.moderator"
          nbButton
          ghost
          status="danger"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="delete()"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit()"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="printReceipt()"
        >
          <nb-icon icon="printer-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
